import {formatIntPrice} from "@/services/formatter";
import {Invoice} from "@/model/billing/Invoice";

export class Debt {
    private constructor(
        readonly id: number,
        readonly person: {
            readonly id: number,
            readonly firstName: string,
            readonly familyName: string,
            readonly wallets: [
                {
                    readonly id: number,
                    readonly currency: string,
                    readonly currentBalance: number,
                }
            ],
        },
        readonly customer: {
            readonly id: number,
            readonly name: string
        },
        readonly status: {
            readonly name: string
        },
        readonly bankIdentificationCode: number,
        readonly boarderGroupCollection: [
            {
                readonly id: number,
                readonly name: string
            }
        ],
        readonly debtOverview: {
            readonly unpaidInvoiceCount: number,
            readonly totalAmountToPay: number,
            readonly maxDelay: number
        },
        readonly debtInvoices: Invoice[] | null
    ) {
    }

    static createFromResponse(item: any): Debt {

        return new Debt(
            item.id,
            item.person,
            item.customer,
            item.status,
            item.bankIdentificationCode,
            item.boarderGroupCollection,
            item.debtOverview,
            item.debtInvoices.map((i: any) => Invoice.createFromResponse(i))
        )
    }

    static createListFromResponse(debtorsList: any[]): Debt[] {
        return debtorsList.map(debtorsItem =>  new Debt(
            debtorsItem.id,
            debtorsItem.person,
            debtorsItem.customer,
            debtorsItem.status,
            debtorsItem.bankIdentificationCode,
            debtorsItem.boarderGroupCollection,
            debtorsItem.debtOverview,
            null
        ))
    }

    get formattedDebtSum(): string {
        return formatIntPrice(this.debtOverview.totalAmountToPay)
    }

    get unpaidInvoiceCount(): string {
        return this.debtOverview.unpaidInvoiceCount.toString()
    }

    get totalAmountToPayNatural(): number {
        return this.debtOverview.totalAmountToPay / 100
    }

    get unpaidInvoiceCountNatural(): number {
        return this.debtOverview.unpaidInvoiceCount
    }
}